export default __webpack_public_path__ + "static/laundry-917434d79aae9892bc80640262926986.jpeg";